import { Sprout, Tag, Repeat } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./Section";

const CARDS = [
  {
    icon: Sprout,
    title: "Sebelum mulai usaha",
    text: "Biaya bahan baku, kemasan, perlengkapan, dan operasional perlu diperhitungkan sebelum kamu menentukan berapa modal yang dibutuhkan.",
  },
  {
    icon: Tag,
    title: "Saat menentukan harga jual",
    text: "Harga jual yang terlihat cocok belum tentu menutup seluruh biaya. Menghitung HPP dan margin membantu kamu membuat keputusan harga dengan pertimbangan yang lebih jelas.",
  },
  {
    icon: Repeat,
    title: "Saat usaha sudah berjalan",
    text: "Omzet yang terlihat besar tidak otomatis berarti usaha menghasilkan keuntungan yang memadai. Biaya dan penjualan perlu dilihat bersama.",
  },
];

export function Problem() {
  return (
    <section className="bg-slate-50 py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading title="Sudah Mengeluarkan Modal, Tapi Sudah Tahu Hitungannya?" />
        </Reveal>
        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.1}>
              <article className="h-full rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-[box-shadow,transform] duration-200 hover:-translate-y-1 hover:shadow-md">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-teal-50 text-teal-700">
                  <c.icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="mt-4 text-lg font-semibold text-slate-900">{c.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{c.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-10 max-w-xl text-center text-base font-medium text-slate-700">
            Daripada terus mengandalkan perkiraan, mulai pahami angka-angka usahamu dengan lebih
            terarah.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
